module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_3009.356ca355.png";